export class MessageConstant {
  static readonly Success = "Saved Successfully!";
  static readonly UpdateSuccess = "Updated Successfully!";
  static readonly DeleteSuccess = "Deleted Successfully!";
  static readonly ActivatedSuccess = "Activated Successfully!";
  static readonly DeactivatedSuccess = "Deactivated Successfully!";
  static readonly FormInvalid = "Invalid Form!";
  static readonly LogoutSuccess = "Logout Successfully!";
  static readonly LoginSuccess = "Login Successfully!";
  static readonly LoginFailed = "Login Failed!";
  static readonly InvalidUserAndPass =
    "Please enter valid username and password!";
  static readonly SelectFileFirst = "Please select file first!";
  static readonly SelectFolderFirst = "Please select folder first!";
  static readonly UploadSuccess = "Uploaded successfully!";
  static readonly UploadFailed = "Upload Failed!";
  static readonly ProvideValidDate = "Please provide valid data.!";
  static readonly SomethingWrong =
    "Something went wrong. Please try again later!";
  static readonly OrderUpdated = "Study has been successfully updated.";
  static readonly OrderSubmitted = "Study has been successfully submitted.";
  static readonly OrderAccepted = "Study has been successfully accepted.";
  static readonly OrderRequested = "Study has been successfully requested.";
  static readonly OrderSSN = "SSN Mandatory";
  static readonly OrderCancel = "Study has been Canceled successfully!";
  static readonly OrderResendToPacs =
    "Resend to data center PACS successfully!";
  static readonly OrderResendToLocalPacs =
    "Study Resend to Local PACS successfully!";
  static readonly OrderAssigned =
    "Study has been successfully Assigned to Imaging Hospital.";
  static readonly OrderDocUploadSuccess =
    "Document has been uploaded successfully.";
  static readonly OrderDocDeleteSuccess =
    "The document has been deleted successfully.";
  static readonly DenyAction = "You didn't want to perform this action!";
  static readonly Unauthorized = "You are not authorized to access!";
  static readonly StudyNotYetAccepted = "Study not yet accepted!";
  static readonly ReportSave = "Study has been saved successfully.";
  static readonly ReportFinalized = "Study has been finalized successfully.";
}
